import { RootState } from "../store";
import { IWagonEventDetailState } from "../types/state";
import { IWagonEventDetail } from "../types/wagonEvent";

export const getWagonEventDetailState = (state: RootState): IWagonEventDetailState => state.wagonEventDetail;
export const getWagonEventDetail = (state: RootState): IWagonEventDetail => state.wagonEventDetail.wagonEvent;